import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Building2, Loader2 } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";

const BG = "https://images.unsplash.com/photo-1583338850703-bc602b103674?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBjb25zdHJ1Y3Rpb24lMjBidWlsZGluZyUyMHRleHR1cmV8ZW58MHx8fHwxNzgyMzMwMjUyfDA&ixlib=rb-4.1.0&q=85";

export default function Login() {
  const { login, formatApiErrorDetail } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("admin@vicon.com");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-slate-50">
      <div className="flex items-center justify-center p-8">
        <form onSubmit={submit} className="w-full max-w-sm" data-testid="login-form">
          <div className="flex items-center gap-2 mb-8">
            <div className="bg-slate-900 text-white p-2 rounded-md"><Building2 size={22} /></div>
            <div>
              <h1 className="font-heading font-900 text-xl font-bold tracking-tight text-slate-900">VICON</h1>
              <p className="text-xs text-slate-500 -mt-1">Construcciones</p>
            </div>
          </div>
          <h2 className="font-heading text-3xl font-bold tracking-tight text-slate-900 mb-1">Iniciar sesión</h2>
          <p className="text-sm text-slate-500 mb-8">Sistema interno de nómina semanal</p>

          <div className="space-y-4">
            <div>
              <Label htmlFor="email" className="text-slate-700">Correo</Label>
              <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)}
                data-testid="login-email" className="mt-1" required />
            </div>
            <div>
              <Label htmlFor="password" className="text-slate-700">Contraseña</Label>
              <Input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)}
                data-testid="login-password" className="mt-1" required />
            </div>
          </div>

          {error && <p className="text-sm text-red-600 mt-4" data-testid="login-error">{error}</p>}

          <Button type="submit" disabled={loading} data-testid="login-submit"
            className="w-full mt-6 bg-slate-900 hover:bg-slate-800 h-11">
            {loading ? <Loader2 className="animate-spin" size={18} /> : "Entrar"}
          </Button>
        </form>
      </div>
      <div className="hidden lg:block relative">
        <img src={BG} alt="Construcción" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-slate-900/60" />
        <div className="absolute bottom-10 left-10 right-10 text-white">
          <p className="font-heading text-2xl font-bold tracking-tight">Control total de nómina, asistencia y préstamos.</p>
          <p className="text-slate-200 mt-2 text-sm">Una sola pantalla. Historial semanal por obra.</p>
        </div>
      </div>
    </div>
  );
}
